<template>
  <div class="w-full overflow-hidden py-4">
    <h2
      class="font-satoshi font-bold text-[14px] leading-[136%] tracking-[0.5em] text-center uppercase mb-2 text-black mt-4 desktop:mt-[23px]"
    >
      {{ t('shell.partnersSlider.title') }}
    </h2>

    <div class="relative w-full overflow-hidden flex items-center justify-center">
      <div
        class="flex animate-scroll"
        :style="`--speed: ${props.speed}s;`"
      >
        <div
          v-for="(logo, index) in duplicatedLogos"
          :key="`logo-${index}`"
          class="flex-shrink-0 flex items-center justify-center me-2"
        >
          <NuxtImg
            :src="logo.src"
            :alt="logo.alt"
            class="h-[47px] w-auto object-contain opacity-60 grayscale hover:opacity-100 hover:grayscale-0 transition-all duration-300"
            :quality="100"
            format="webp"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();

interface PartnerLogo {
  src: string;
  alt: string;
}

const props = withDefaults(
  defineProps<{
    logos?: PartnerLogo[];
    speed?: number;
  }>(),
  {
    logos: () => [
      { src: '/images/logos/al-habtoor.webp', alt: 'AL HABTOOR' },
      { src: '/images/logos/damac.webp', alt: 'DAMAC' },
      { src: '/images/logos/emaar.webp', alt: 'EMAAR' },
      { src: '/images/logos/majid.webp', alt: 'MAJID AL FUTTAIM' },
      { src: '/images/logos/pantheon.webp', alt: 'PANTHEON DEVELOPMENT' },
      { src: '/images/logos/nakheel.webp', alt: 'NAKHEEL' },
      { src: '/images/logos/omniyat.webp', alt: 'by OMNIYAT' },
      { src: '/images/logos/arada.webp', alt: 'ARADA' },
      { src: '/images/logos/darglobal.webp', alt: 'DARGLOBAL' },
      { src: '/images/logos/sobha.webp', alt: 'SOBHA' },
      { src: '/images/logos/select-group.webp', alt: 'SELECT GROUP' },
      { src: '/images/logos/meraas.webp', alt: 'MERAAS' },
      { src: '/images/logos/mag.webp', alt: 'MAG' },
      { src: '/images/logos/ellington.webp', alt: 'ELLINGTON' },
      { src: '/images/logos/dubaiproperties.webp', alt: 'DUBAI PROPERTIES' },
      { src: '/images/logos/deyaar.webp', alt: 'DEYAAR' },
      { src: '/images/logos/danube.webp', alt: 'DANUBE' },
      { src: '/images/logos/binghati.webp', alt: 'BINGHATI' },
      { src: '/images/logos/the-first-group.webp', alt: 'THE FIRST GROUP' },
    ],
    speed: 30,
  },
);

const duplicatedLogos = computed(() => {
  return [...props.logos, ...props.logos, ...props.logos];
});
</script>

<style scoped>
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-100% / 3));
  }
}

.animate-scroll {
  display: flex;
  will-change: auto;
  animation: scroll var(--speed, 30s) linear infinite;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}

/* RTL: scroll toward the reading end (mirror of `scroll`). */
@keyframes scroll-rtl {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(100% / 3));
  }
}

[dir='rtl'] .animate-scroll {
  animation-name: scroll-rtl;
}
</style>
